import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BLOG_URL } from '@app/config';
import { JsonLdService, MetaService } from '@app/core';
import {
  AppIconSectionComponent,
  BlogPost,
  BlogSectionComponent,
  CustomerLogoSectionComponent,
  TestimonialsSectionComponent,
  VideoSectionComponent,
} from '@app/widgets';
import { LIVE_UPDATES_FAQS } from '../../constants';
import { LiveUpdatesCtaSectionComponent } from '../live-updates-cta-section/live-updates-cta-section.component';
import { LiveUpdatesFaqSectionComponent } from '../live-updates-faq-section/live-updates-faq-section.component';
import { LiveUpdatesFeaturesSectionComponent } from '../live-updates-features-section/live-updates-features-section.component';
import { LiveUpdatesHeroSectionComponent } from '../live-updates-hero-section/live-updates-hero-section.component';
import { LiveUpdatesHowItWorksSectionComponent } from '../live-updates-how-it-works-section/live-updates-how-it-works-section.component';
import { LiveUpdatesIntegrationSectionComponent } from '../live-updates-integration-section/live-updates-integration-section.component';
import { LiveUpdatesStatisticsSectionComponent } from '../live-updates-statistics-section/live-updates-statistics-section.component';

@Component({
  selector: 'app-live-updates',
  imports: [
    AppIconSectionComponent,
    BlogSectionComponent,
    CustomerLogoSectionComponent,
    LiveUpdatesCtaSectionComponent,
    LiveUpdatesFaqSectionComponent,
    LiveUpdatesFeaturesSectionComponent,
    LiveUpdatesHeroSectionComponent,
    LiveUpdatesHowItWorksSectionComponent,
    LiveUpdatesIntegrationSectionComponent,
    LiveUpdatesStatisticsSectionComponent,
    TestimonialsSectionComponent,
    VideoSectionComponent,
  ],
  templateUrl: './live-updates.component.html',
  styleUrl: './live-updates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveUpdatesComponent {
  protected readonly blogPosts: BlogPost[] = [
    // {
    //   title: 'How Live Updates for Capacitor work',
    //   description:
    //     'Discover how Capawesome Cloud enables seamless live updates for your Capacitor apps, allowing you to deliver updates without going through app stores.',
    //   date: 'July 22, 2024',
    //   authorName: 'Robin Genz',
    //   authorDescription: 'Maintainer',
    //   authorImageUrl:
    //     'https://capawesome.io/assets/external/avatars.githubusercontent.com/u/13857929.jpg',
    //   link: `${BLOG_URL}how-live-updates-for-capacitor-work/`,
    //   tag: 'Guides',
    // },
    {
      title: 'How Usage is Tracked in Capawesome Cloud',
      description:
        'Learn how Capawesome Cloud tracks usage for Capacitor Live Updates, ensuring you stay within your plan limits and understand your app’s performance.',
      date: 'July 19, 2025',
      authorName: 'Robin Genz',
      authorDescription: 'Maintainer',
      authorImageUrl:
        'https://capawesome.io/assets/external/avatars.githubusercontent.com/u/13857929.jpg',
      link: `${BLOG_URL}how-usage-is-tracked-in-capawesome-cloud/`,
      tag: 'Development',
    },
    {
      title: 'How to gradually roll out Capacitor Live Updates',
      description:
        'Learn how to safely roll out updates to your Capacitor apps using Capawesome Cloud’s gradual rollout feature, minimizing risks and ensuring a smooth user experience.',
      date: 'May 29, 2024',
      authorName: 'Robin Genz',
      authorDescription: 'Maintainer',
      authorImageUrl:
        'https://capawesome.io/assets/external/avatars.githubusercontent.com/u/13857929.jpg',
      link: `${BLOG_URL}how-to-gradually-roll-out-capacitor-live-updates/`,
      tag: 'Development',
    },
    {
      title: 'How to restrict Capacitor Live Updates to Native Versions',
      description:
        'Learn how to ensure only compatible updates are delivered to your users by restricting live updates to specific native versions using Capawesome Cloud.',
      date: 'May 6, 2024',
      authorName: 'Robin Genz',
      authorDescription: 'Maintainer',
      authorImageUrl:
        'https://capawesome.io/assets/external/avatars.githubusercontent.com/u/13857929.jpg',
      link: `${BLOG_URL}how-to-restrict-capacitor-live-updates-to-native-versions/`,
      tag: 'Development',
    },
  ];

  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Capawesome Cloud enables modern app development teams to deliver updates to their Capacitor apps without pushing to the app stores.',
    );
    this.metaService.setTitle('Live Updates for Capacitor');
    this.metaService.setKeywords([
      'Capacitor live updates',
      'OTA updates',
      'over-the-air updates',
      'hot updates',
      'code push',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Live Updates for Capacitor - Capawesome Cloud',
        'Deliver updates to your Capacitor apps without pushing to the app stores.',
        'https://cloud.capawesome.io/live-updates/',
      ),
      JsonLdService.buildFaqSchema(LIVE_UPDATES_FAQS),
    ]);
  }
}
